module.exports = __webpack_public_path__ + "img/custom-design.813a2204.png";